import React, { useEffect, useState } from "react";
import { Modal, Spinner, Table, Badge, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { fetchDeliverableHistoryById } from "../../../../store/features/deliverable/deliverableSlice";
import { IoDocumentTextOutline } from "react-icons/io5";
import ReactPaginate from "react-paginate";

const DeliverableHistoryModal = ({
  selectedDeliverable,
  showDeliverableHistory,
  setShowDeliverableHistory,
}) => {
  const { deliverableHistory, loading, deliverableHistoryPagination } =
    useSelector((state) => state.deliverables);
  const { managers, staffs } = useSelector((state) => state.users);
  const { projects } = useSelector((state) => state.projects);
  const { workPackages } = useSelector((state) => state.workPackages);

  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();
  const limit = 10;

  useEffect(() => {
    dispatch(
      fetchDeliverableHistoryById({
        deliverableId: selectedDeliverable.deliverableId,
        currentPage,
        limit,
      })
    );
  }, [selectedDeliverable.deliverableId, currentPage]);

  return (
    <Modal
      size="lg"
      show={showDeliverableHistory}
      onHide={() => setShowDeliverableHistory(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{selectedDeliverable.title} (Histroy)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          {loading ? (
            <Spinner animation="border" />
          ) : (
            <>
              <div className="table-wrapper">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Title/Name</th>
                      <th>Description</th>
                      <th>Project</th>
                      <th>Workpackage</th>
                      <th>Assigned To</th>
                      <th>Deliverble Number</th>
                      <th>Cost</th>
                      <th>Status</th>
                      <th>Start date</th>
                      <th>End date</th>
                      <th>Attachments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deliverableHistory?.map(({ history }) => (
                      <tr key={history.id}>
                        <td>{history.title}</td>
                        <td>{history.description}</td>
                        <td>{projects?.find(p=> p._id === history.projectId)?.projectName}</td>
                        <td>{workPackages?.find(w=> w._id === history.wpId)?.title}</td>
                        <td>{(managers?.find(u=> u._id === history.assignedTo)?.name) || (staffs?.find(s=> s._id === history.assignedTo)?.name)}</td>
                        <td>{history.dlvNumber}</td>
                        <td>{history.cost}</td>
                        <td>{history.status}</td>
                        <td>
                          {history.startDate &&
                            format(history.startDate, "MM/dd/yyyy")}
                        </td>
                        <td>
                          {history.endDate &&
                            format(history.endDate, "MM/dd/yyyy")}
                        </td>
                        <td style={{ minWidth: 120 }}>
                          {Array.isArray(history.deliverablesFiles) &&
                            history.deliverablesFiles.length > 0 && (
                              <div className="d-flex flex-wrap">
                                {history.deliverablesFiles?.map((doc) => (
                                  <Button variant="light" className="me-1">
                                    <a
                                      href={doc}
                                      target="_blank"
                                      rel="noreferrer"
                                      download
                                    >
                                      <IoDocumentTextOutline size="1.2rem" />
                                    </a>
                                  </Button>
                                ))}
                              </div>
                            )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {deliverableHistoryPagination?.totalPages > 1 && (
                  <div className="d-flex justify-content-center mt-3">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next >"
                      onPageChange={(e) => setCurrentPage(e.selected)}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      pageCount={deliverableHistoryPagination.totalPages}
                      previousLabel="< Prev"
                      forcePage={currentPage}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </>
      </Modal.Body>
    </Modal>
  );
};

export default DeliverableHistoryModal;
